import React, { useState } from "react"
import Modal from "react-modal"
import styled, { keyframes } from "styled-components"
import Lottie from "react-lottie"

const zoomAnime = keyframes`
  0%{
    transform: scale(0.9);
  }
  100%{
    transform: scale(1);
  }
`
const Wrap = styled.div`
  height: 0;
  margin: auto;
  padding-top: 87.46%;
  position: relative;
  animation: ${zoomAnime} 1s ease;
  will-change: transform;
`
const customStyles = {
  overlay: {
    backgroundColor: "rgba(0,0,0,.8)",
  },
  content: {
    background: "none",
    border: "0",
    top: "0",
    left: "0",
    bottom: "0",
    right: "0",
    margin: "auto",
    padding: "0",
  },
}
const ImageWrap = styled.div`
  margin: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`
const UmeImageWrap = styled(ImageWrap)`
  width: 100%;
`
const StyledImg = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`

// ImageList
const modalBg1 = require("../../images/gratz/01.png")
const modalBg2 = require("../../images/gratz/02.png")
const modalBg3 = require("../../images/gratz/03.png")
const modalBg4 = require("../../images/gratz/04.png")
const modalUme1 = require("../../images/gratz/ume01.png")
const modalUme2 = require("../../images/gratz/ume02.png")
const modalUme3 = require("../../images/gratz/ume03.png")
const modalUme4 = require("../../images/gratz/ume04.png")
const modalBgList: string[] = [modalBg1, modalBg2, modalBg3, modalBg4]
const modalUmeList: string[] = [modalUme1, modalUme2, modalUme3, modalUme4]
for (var i = 3; i >= 0; i--) {
  var r = Math.floor(Math.random() * (i + 1))
  var tmpBg = modalBgList[i]
  var tmpUme = modalUmeList[i]
  modalBgList[i] = modalBgList[r]
  modalUmeList[i] = modalUmeList[r]
  modalBgList[r] = tmpBg
  modalUmeList[r] = tmpUme
}

Modal.setAppElement("#___gatsby")
const ModalWindow = props => {
  const index = props.index
  const [modalState, setModal] = useState(true)
  const [isUme, setUme] = useState(false)
  const [isBg, setBg] = useState(false)

  const afterOpenModal = () => {}
  const closeModal = () => {
    setModal(false)
  }
  const motion = require("../../data/animate.json")
  const lottieOptions = {
    loop: false,
    autoplay: true,
    animationData: motion,
  }

  let modalBg
  let modalUme

  if (index < 3) {
    modalBg = modalBgList[0]
    modalUme = modalUmeList[0]
  } else if (index < 6) {
    modalBg = modalBgList[1]
    modalUme = modalUmeList[1]
  } else {
    modalBg = modalBgList[2]
    modalUme = modalUmeList[2]
  }
  const ume = new Image()
  ume.src = modalUme
  ume.onload = () => {
    setUme(true)
  }
  const bg = new Image()
  bg.src = modalBg
  bg.onload = () => {
    setBg(true)
  }

  return (
    <Modal
      isOpen={modalState}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="GratzModal"
      closeTimeoutMS={500}
    >
      {isUme && isBg && (
        <Wrap>
          <ImageWrap>
            <StyledImg src={modalBg} alt="modalBg" />
          </ImageWrap>
          <ImageWrap>
            <Lottie options={lottieOptions} height="100%" width="100%" />
          </ImageWrap>
          <UmeImageWrap>
            <StyledImg src={modalUme} alt="modalUme" />
          </UmeImageWrap>
        </Wrap>
      )}
    </Modal>
  )
}
export default ModalWindow
